import { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { doApiCall } from "./utils";

const { REACT_APP_REGISTRATION_API_URL } = process.env;

export interface PaymentLinkResponse {
  glMemberId: string;
  ecommerceLink: string;
}

export interface PaymentLinkApiResponse {
  data: PaymentLinkResponse;
  meta?: { message?: string; details?: string | null };
}

export const getPaymentLink = (): Promise<
  AxiosResponse<PaymentLinkApiResponse> | AxiosError
> => {
  const request: AxiosRequestConfig = {
    method: "GET",
    url: `https://${REACT_APP_REGISTRATION_API_URL}/membership/payment-link`
  };

  return doApiCall(request);
};

/** Request body for `POST /membership/referrals/payment-link` (OpenAPI `GiftingRecipient`). */
export type GiftingRecipient = {
  email: string;
  firstName: string;
  lastName: string;
};

export type ReferralsPaymentLinkRequestBody = {
  recipients: GiftingRecipient[];
};

/**
 * Gift / referral checkout iframe URL. Response matches {@link PaymentLinkApiResponse}
 * (same shape as {@link getPaymentLink}).
 */
export const postMembershipReferralsPaymentLink = (
  body: ReferralsPaymentLinkRequestBody
): Promise<AxiosResponse<PaymentLinkApiResponse> | AxiosError> => {
  const request: AxiosRequestConfig = {
    data: body,
    method: "POST",
    url: `https://${REACT_APP_REGISTRATION_API_URL}/membership/referrals/payment-link`
  };

  return doApiCall(request);
};

export type UserMfa = {
  mfaEnforcedOnLogin: boolean;
};

export type UserMfaResponse = {
  data: UserMfa;
  meta?: {
    message?: string;
    details?: string;
  };
};

export const getMemberMfaEnforcedStatus = () => {
  const request: AxiosRequestConfig = {
    method: "GET",
    url: `https://${REACT_APP_REGISTRATION_API_URL}/user/mfa`
  };

  return doApiCall(request);
};

/**
 * Set MFA Enforcement Status for the current user.
 */
export const patchUserMfaEnforcedStatus = (status: boolean) => {
  const payload: UserMfa = { mfaEnforcedOnLogin: status };
  const request: AxiosRequestConfig = {
    method: "PATCH",
    url: `https://${REACT_APP_REGISTRATION_API_URL}/user/mfa`,
    data: payload
  };

  return doApiCall(request);
};

/**
 * Enable MFA enforcement for the current user.
 */
export const enableMfa = () => {
  return patchUserMfaEnforcedStatus(true);
};

/**
 * Disable MFA enforcement for the current user.
 */
export const disableMfa = () => {
  return patchUserMfaEnforcedStatus(false);
};
